import {
  jb_breadcrumbs_back_link_css_default
} from "./chunk.L4CONHF6.js";
import {
  Linkable
} from "./chunk.MFPI4EPN.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-breadcrumbs-back-link/jb-breadcrumbs-back-link.ts
var JbBreadcrumbsBackLink = class extends Linkable(r) {
  constructor() {
    super(...arguments);
    this._hover = false;
  }
  _mouseInHandler() {
    this._hover = true;
  }
  _mouseOutHandler() {
    this._hover = false;
  }
  render() {
    return ke`
      <a
        data-linkable
        @mouseover=${this._mouseInHandler}
        @mouseout=${this._mouseOutHandler}
        @focus=${this._mouseInHandler}
        @blur=${this._mouseOutHandler}
        class="${Rt({ hover: this._hover })}"
      >
        <span>${this.text}</span>
        <svg
          width="15"
          height="10"
          viewbox="0 0 15 10"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill-rule="evenodd">
            <path
              d="M.978 5.37a.596.596 0 0 1 0-.835L4.811.656a.58.58 0 0 1 .826 0 .596.596 0 0 1 0 .836l-3.42 3.46 3.42 3.46a.596.596 0 0 1 0 .837.58.58 0 0 1-.826 0L.978 5.37z"
            ></path>
            <path d="M15.6 5.583h-14v-1h14z"></path>
          </g>
        </svg>
      </a>
    `;
  }
};
JbBreadcrumbsBackLink.styles = [reset_css_default, jb_breadcrumbs_back_link_css_default];
__decorateClass([
  n()
], JbBreadcrumbsBackLink.prototype, "text", 2);
__decorateClass([
  r2()
], JbBreadcrumbsBackLink.prototype, "_hover", 2);
JbBreadcrumbsBackLink = __decorateClass([
  customElement("jb-breadcrumbs-back-link")
], JbBreadcrumbsBackLink);

export {
  JbBreadcrumbsBackLink
};
